import { useCallback } from 'react'

import { faHashtag } from '@fortawesome/pro-regular-svg-icons'

import { EVENT_TYPES } from 'common/track-event-constants'

import LinkListItem from '../../LinkListItem'
import { getSearchURL } from '../get-search-url'
import { useClickTracking } from '../use-click-tracking'
import { useOnSaveSearchHistory } from '../use-on-save-search-history'

export const getTo = getSearchURL

interface IResultComponentProps {
  label: string
  id?: string
}

const ResultComponent = ({ label, id }: IResultComponentProps) => {
  const trackClickFn = useClickTracking(EVENT_TYPES.CONTENT_TAG_SEARCH_CLICK)
  const onSaveSearchHistory = useOnSaveSearchHistory({ Label: label })

  const onClick = useCallback(() => {
    onSaveSearchHistory()
    trackClickFn()
  }, [onSaveSearchHistory, trackClickFn])

  return (
    <LinkListItem
      id={id}
      to={getSearchURL(label)}
      hoverText={`Search for content by tag ${label}`}
      label={label}
      onClick={onClick}
      icon={faHashtag}
    />
  )
}

export default ResultComponent
